angular.module('satv.mediastats')
    .controller('MediaStatsSearchCtrl', ['$scope', '$state', '$stateParams', 'StatLoader', function($scope, $state, $stateParams, StatLoader) {

        $scope.terms = angular.copy($stateParams);
        $scope.searchterms = angular.copy($stateParams);

        $scope.search = function(terms) {

            if (!terms.groupBy && terms.sortBy === 'total') {
                terms.sortBy = 'mre.createdDate';
            }
            $scope.searchterms = angular.copy(terms);
            $state.go('statSearch', terms);
        };

        $scope.statLoader = new StatLoader({
            type: $scope.terms.type,
            fromDate: $scope.terms.fromDate,
            toDate: $scope.terms.toDate,
            textQuery: $scope.terms.textQuery,
            groupBy: $scope.terms.groupBy,
            sortBy: $scope.terms.sortBy,
            sortOrder: $scope.terms.sortOrder,
            includeTotal:  $scope.terms.includeTotal,
            'context[name]': $scope.terms.context ? $scope.terms.context.name : undefined,
            'context[data]': $scope.terms.context ? $scope.terms.context.data : undefined
        }).getFirstPage();

        $scope.getUserDetails = function(stat) {
            return 'User ID: ' + stat.user.id;
        };

        $scope.getRequestDetails = function(stat) {
            return stat.user_agent;
        };

        $scope.getContextDetails = function(stat) {
            return stat.context.data;
        };

        $scope.searchUserStats = function(stat) {
            $state.go('statSearch', {
                textQuery: stat.user.email,
                context: undefined,
                groupBy: undefined,
                fromDate: undefined,
                toDate: undefined,
                sortBy: 'mre.createdDate',
                sortOrder: 'desc'
            });
        };

        $scope.searchIpStats = function(stat) {
            $state.go('statSearch', {
                textQuery: stat.request_ip,
                context: undefined,
                groupBy: undefined,
                fromDate: undefined,
                toDate: undefined,
                sortBy: 'mre.createdDate',
                sortOrder: 'desc'
            });
        };

        $scope.searchContextStats = function(stat) {
            $state.go('statSearch', {
                context: stat.context,
                groupBy: undefined,
                textQuery: undefined,
                fromDate: undefined,
                toDate: undefined,
                sortBy: 'mre.createdDate',
                sortOrder: 'desc'
            });
        };

        $scope.reset = function() {
            var terms = {
                type: 'audition',
                sortBy: 'mre.createdDate',
                sortOrder: 'DESC',
                includeTotal: 'true',
                textQuery: null,
                fromDate: null,
                toDate: null,
                groupBy: null,
            };

            $scope.terms = terms;
            $state.go('statSearch', terms);
        };
    }]);




// WEBPACK FOOTER //
// ./vendor/sonyatv/mediastatsclientbundle/Resources/js/angular/controllers/MediaStatsSearchCtrl.js